import React, { useContext, useEffect, useRef, useState } from 'react';
import { AppContext } from '../../App';
import AgendaStreamingSelection from '../../common/AgendaStreamingSelection';
import SportSelection from '../../common/SportSelection';
import { getBetgeniusStreamingProps, getBetgeniusV3StreamingProps, getBetradarStreamingProps, getArenaStreamingProps, getIgameMediaStreamingProps} from '../../data/streaming/streamingUtils';
import { classIf } from '../../data/utils/classIf';
import { getConfiguration } from '../../data/utils/configuration';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import { labels } from '../../data/labels';
import { isOverlaySection } from '../../utils/sport-effects';
import { LiveContext } from '../Live';

function LiveSporstNav(props) {
    const conf = getConfiguration();
    const appContext = useContext(AppContext);
    const liveContext = React.useContext(LiveContext);
    const [showSortMenu, setShowSortMenu] = useState(false);
    const navRef = useRef(null);
    const isStreamingEnabled = getBetgeniusStreamingProps() || getBetgeniusV3StreamingProps() || getBetradarStreamingProps() ||  getArenaStreamingProps() || getIgameMediaStreamingProps();

    const favoritesCount = Object.keys(liveContext.favorites).length;

    function toggleSortMenu() {
        if(liveContext.section!=='calendar' && liveContext.section!=='agenda-streaming')
            setShowSortMenu(!showSortMenu);
    }
    
    function toggleCalendar() {
        liveContext.toggleCalendar();
    }

    function toggleCasino() {
        liveContext.toggleCasino();
    }

    function toggleAgendaStreaming() {
        liveContext.toggleAgendaStreaming();
    }
    
    function toggleFavorites() {
        liveContext.toggleFavorites();
    }

    function changeSortType(type) {
        toggleSortMenu();
        liveContext.setSortType(type);
    }
    
    const sportSelectionsList = props.sports &&  props.sports.map(function(sport,index) {
        function handleClick() {
            props.changeSport(sport.id)
        }
        return (
                <SportSelection key={sport.id} {...sport} order={index+1} counter={sport.eventsCount} selected={props.currentSport && (sport.id === props.currentSport.id)} isLiveSuite={true} handleClick={handleClick} />
        );
    });

    useEffect(() => {       
        liveContext.setNavLiveSportsRef(navRef.current);
        if(navRef.current && liveContext.navLiveSportsScroll!==0){
            navRef.current.scrollLeft = liveContext.navLiveSportsScroll;
        }
    }, []);
    
    const hideWrapper = isOverlaySection(appContext,props.section);
    
    return (
        <>
        {!appContext.hideMenu && 
            <div className={"nav-slider-container" + classIf(hideWrapper, 'd-none')}>
                <nav ref={navRef} id="nav-live-sports" className="nav-slider">
                    <div className={"nav-slider-item-container sport-img-slider icona-preferiti" + classIf(liveContext.section==='favorites', 'selected')} style={{order: 0}} onClick={toggleFavorites}>
                        <div className="sport-img-slider-count">{favoritesCount}</div>
                        <div className="sport-img-container">
                            <i className="fa fa-star giallo nav-slider-fav-icon align-self-center push-left push-right"></i>
                        </div>
                        <div className="nav-slider-item">{labels['live.navbar.favorites']}</div>
                    </div>
                    {sportSelectionsList}
                    {isStreamingEnabled &&
                        <AgendaStreamingSelection key={'agenda-streaming-selection'} order={props.sports?props.sports.length+2:null} selected={liveContext.section === 'agenda-streaming'} onClick={toggleAgendaStreaming}  />
                    }
                    <div className={"nav-slider-item-container sport-img-slider icona-calendar" + classIf(liveContext.section === 'calendar', 'selected')} style={{order: props.sports?props.sports.length+1:null}} onClick={toggleCalendar}>
                        <div className="sport-img-container">
                            <div className={`sport-img ${iconSportCssClass('Calendar')}`}></div>
                        </div>
                        <div className="nav-slider-item">{labels['live.navbar.events_schedule']}</div>
                    </div>
                    {conf.urlCasino?.length > 0 &&
                        <div className={"nav-slider-item-container sport-img-slider" + classIf(liveContext.section === 'casino', 'selected')} onClick={toggleCasino}>
                            <div className="sport-img-container">
                                <div className="sport-img cg-ico-casino-xs"></div>
                            </div>
                            <div className="nav-slider-item">Casino</div>
                        </div>
                    }
                </nav>
                {showSortMenu ?
                    <div className="nav-slider-menu">
                        <div className="nav-slider-menu-close-button push-right" onClick={toggleSortMenu}>
                            <i className="fa fa-times"></i>
                        </div>
                        <div className={"nav-slider-menu-row" + classIf(liveContext.sortType === 'league', 'selected')} onClick={() => {changeSortType('league')}}>
                            <i className="fa fa-sort-alpha-down"></i>
                            <span>{labels['live.navbar.sort_popup.sort_by_tournament']}</span>
                        </div>
                        <div className={"nav-slider-menu-row" + classIf(liveContext.sortType === 'desc', 'selected')} onClick={() => {changeSortType('desc')}}>
                            <i className="fa fa-sort-down"></i>
                            <span>{labels['live.navbar.sort_button.sort_by_reverse_chronological_order']}</span>
                        </div>
                        <div className={"nav-slider-menu-row" + classIf(liveContext.sortType === 'asc', 'selected')} onClick={() => {changeSortType('asc')}}>
                            <i className="fa fa-sort-up"></i>
                            <span>{labels['live.navbar.sort_button.sort_by_chronological_order']}</span>
                        </div>
                    </div>
                    :
                    <div className={`nav-slider-button ${(liveContext.section==='calendar' || liveContext.section==='agenda-streaming' )?'opacity-03':''}`} onClick={toggleSortMenu}>
                        <i className="fa fa-sort-alpha-down"></i>
                        <span>{labels['live.navbar.sort_button.title']}</span>
                    </div>
                }
            </div>
        }
        </>
    );
}


export default LiveSporstNav;
